import { usePageRuntime } from '@Pages/pageRuntime/pageRuntimeContextValue';
import type { SdkAccountingEntities, SdkAccountingEntity } from '@Pages/pageRuntime/sdk/types';

import { useApi } from './useApi';

const NO_ENTITIES: SdkAccountingEntity[] = [];

export function useAccountingEntities(): SdkAccountingEntities {
  const sdk = usePageRuntime()?.Sdk;
  const signedIn = (sdk?.identity ?? null) !== null;
  const query = useApi(
    ['accounting-entities', sdk?.workspace?.id ?? null],
    (api) => api.get<{ data: SdkAccountingEntity[] }>('/api/wallet/accounting-entity-options'),
    { enabled: signedIn }
  );

  return {
    entities: signedIn ? (query.data?.data ?? NO_ENTITIES) : NO_ENTITIES,
    isLoading: signedIn && query.isLoading,
    error: signedIn ? query.error : null
  };
}
